import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { NotificationService } from '../../domain/notifications/notification.service';
import { environment } from '../../environments/environment';
import { NoopAction } from '../actions/app.actions';
import {
  ENotificationsActions,
  StartNotifications,
  ListNotifications,
  ListNotificationsFailure,
  ListNotificationsSuccess,
  ReadNotifications,
} from '../actions/notifications.actions';
import { UserExtraSaved } from '../actions/user-extra.actions';
import { of } from 'rxjs';

@Injectable()
export class NotificationsEffects {
  constructor(private notificationService: NotificationService) {}

  private readonly actions$ = inject(Actions);

  start$ = createEffect(() =>
    this.actions$.pipe(
      ofType<StartNotifications>(ENotificationsActions.StartNotifications),
      switchMap(() => {
        if (
          environment.notifications.enabled &&
          environment.notifications.timing > 0
        ) {
          return of(new ListNotifications());
        }
        return of(new NoopAction());
      })
    )
  );

  list$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ListNotifications>(ENotificationsActions.ListNotifications),
      switchMap(() =>
        this.notificationService.list().pipe(
          map(payload => new ListNotificationsSuccess(payload)),
          catchError(() => of(new ListNotificationsFailure()))
        )
      )
    )
  );

  readNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType<ReadNotifications>(ENotificationsActions.ReadNotifications),
      switchMap(action => of(new UserExtraSaved(action.payload)))
    )
  );
}
